export class WaterFacts {
	public waterFactElement = document.getElementById('water-fact') as HTMLElement;
	protected waterFactTextElement = document.getElementById('water-fact-text') as HTMLElement;
	protected waterFactImageElement = document.getElementById('water-fact-image') as HTMLImageElement;

	private facts = [
		{
			region: 'US',
			icon: './static/images/fact-icons/03-jw-icon.svg',
			text: 'JUST is 100% mountain-sourced spring water with naturally occurring mineral content and pH of 8.',
		},
		{
			region: 'US',
			icon: './static/images/fact-icons/04-jw-icon.svg',
			text: 'Thanks to plentiful annual snow and rain-fall, the Glens Falls watershed is constantly replenished.  ',
		},
		{
			region: 'US',
			icon: './static/images/fact-icons/05-jw-icon.svg',
			text: 'The Glens Falls community only uses about half of the water in the watershed and JUST bottles a fraction of what remains!',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/06-jw-icon.svg',
			text: 'Between 50% and 80% of the human body is made up of water.',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/07-jw-icon.svg',
			text: 'All of the body’s chemical processes depend on proper hydration: digestion, nutrient absorption, getting rid of waste, regulating body temperature, normal brain and muscle function, and so much more!',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/08-jw-icon.svg',
			text: 'Being well-hydrated improves sleep quality, cognition, and mood.',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/09-jw-icon.svg',
			text: 'No additives, preservatives, colors, calories or sweeteners added to JUST Infused water. 100% spring water plus 100% fruit essence. The result: pure flavor.',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/10-jw-icon.svg',
			text: 'JUST Water has a pH of 8 which makes it naturally alkaline. This means our water hasn’t been artificially processed to add minerals and boost the pH. It’s simply spring water that runs over natural rock formations and absorbs the minerals in it as it does.',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/11-jw-icon.svg',
			text: 'We get about one fifth of the water we need from food and the rest from drinking fluids. ',
		},
		{
			region: 'ALL',
			icon: './static/images/fact-icons/12-jw-icon.svg',
			text: 'The body loses water throughout the day through breathing and sweating, as well as by going to the toilet. That’s why replenishing is so important!',
		},
	];

	private readFacts: any[] = [];

	public constructor() {}

	public preloadFact(): void {
		if (this.facts.length === 0) {
			this.facts = this.readFacts;
			this.readFacts = [];
		}
		const fact = this.facts.splice(this.getRandomNumber(), 1)[0];
		this.readFacts.push(fact);
		this.waterFactTextElement.innerText = fact.text;
		this.waterFactImageElement.src = fact.icon;
	}

	public showFact(): void {
		this.waterFactElement.style.display = 'flex';
	}

	public hideFact(): void {
		this.waterFactElement.classList.add('fade-out');
		setTimeout(() => {
			this.waterFactElement.style.display = 'none';
			this.waterFactElement.classList.remove('fade-out');
		}, 1100); // 100ms more than the animation declared in the css file
	}

	private getRandomNumber(): number {
		const min = 0;
		const max = this.facts.length;
		return Math.random() * (max - min) + min;
	}
}
